export const getPageContentFulfilledReducer = (state, action) => {
  state.content.isDataLoaded = true;
  state.content.store = {
    ...state.content.store,
    [action.payload.tag]: {
      ...state.content.store[action.payload.tag],
      [action.payload.languageCode]: action.payload.data,
    },
  };

  state.content.isLoading = false;
};

export const getPageContentPendingReducer = state => {
  state.content.isLoading = true;
};

export const getPageContentRejectedReducer = (state, action) => {
  state.content.isDataLoaded = false;
  state.content.isFetchError = action.payload || true;
  state.content.isLoading = false;
};

export const serverSeoSaveReducer = (state, action) => {
  state.content.isDataLoaded = true;

  state.content.store = {
    [action.payload.tag]: {
      [action.payload.locale]: action.payload.data,
    },
  };
  state.content.isLoading = false;
};

export const getAllCountriesPendingReducer = state => {
  state.allCountries.isLoading = true;
};

export const getAllCountriesRejectedReducer = (state, action) => {
  state.allCountries.isLoading = false;
  state.allCountries.isDataLoaded = false;
  state.allCountries.isFetchError = action.payload || true;
};

export const getAllCountriesFulfilledReducer = (state, action) => {
  state.allCountries.isDataLoaded = true;

  state.allCountries.data = {
    ...state.allCountries.data,
    [action.payload.languageCode]: action.payload.data,
  };

  state.allCountries.isLoading = false;
};

export const getCountryInfoFulfilledReducer = (state, action) => {
  state.countryInfo.isDataLoaded = true;
  state.countryInfo.data = action.payload;
};

export const getCountryInfoRejectedReducer = state => {
  state.countryInfo.isDataLoaded = false;
  state.countryInfo.data = {};
};

export const getMenuProxyPendingReducer = state => {
  state.menuProxy.isLoading = true;
};

export const getMenuProxyRejectedReducer = (state, action) => {
  state.menuProxy.isLoading = false;
  state.menuProxy.isDataLoaded = false;
  state.menuProxy.isFetchError = action.payload || true;
};

export const getMenuProxyFulfilledReducer = (state, action) => {
  state.menuProxy.isDataLoaded = true;

  state.menuProxy.data = {
    ...state.menuProxy.data,
    [action.payload.languageCode]: action.payload.data,
  };

  state.menuProxy.isLoading = false;
};

export const getHTMLCodePendingReducer = state => {
  state.html.isLoading = true;
};

export const getHTMLCodeRejectedReducer = (state, action) => {
  state.html.isLoading = false;
  state.html.isDataLoaded = false;
  state.html.isFetchError = action.payload || true;
};

export const getHTMLCodeFulfilledReducer = (state, action) => {
  state.html.isDataLoaded = true;
  state.html.data = action.payload;
  state.html.isLoading = false;
};
